import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<unknown>, next: HttpHandler) {
		const authRequest = req.clone({
			setHeaders: {
				'Cache-Control': 'no-cache',
				Pragma: 'no-cache',
			},
		});
		return next.handle(authRequest);
	}
}
